export default {
    heroTitle: "The springboard to your international future",
    heroDescription: "Prepare for IELTS, TOEFL, TCF France and TCF Canada with mock tests, expert resources and progress tracking — all in one place.",
    primaryCallToActionLabel: "Prepare with LinguaScore",
    primaryCallToActionLabelAlt: "Start your preparation",
    secondaryCallToActionLabel: "View Pricing",
    footerCallToActionTitle: "Ready to start your journey?",
    footerCallToActionDescription: "Join Linguascore and get access to mock tests, resources and progress tracking.",
    footerCallToActionPrimaryButtonLabel: "Create free account",
    footerCallToActionSecondaryButtonLabel: "Log in",
}